// extracted by mini-css-extract-plugin
export default {"container":"TableModal_container__4zUzm","title":"TableModal_title__reKM8","text":"TableModal_text__u4Jv9","button":"TableModal_button__xycAy"};